/** Fuerza descarga de un SW nuevo y recarga (útil cuando la PWA instalada queda en caché vieja). */
export async function forcePwaUpdate(): Promise<void> {
  if ('serviceWorker' in navigator) {
    const regs = await navigator.serviceWorker.getRegistrations();
    await Promise.all(regs.map((r) => r.unregister()));
  }
  if ('caches' in window) {
    const keys = await caches.keys();
    await Promise.all(keys.map((k) => caches.delete(k)));
  }
  const url = new URL(window.location.href);
  url.searchParams.set('_pwa', String(Date.now()));
  window.location.replace(url.toString());
}
